import allEnvs from "../env.config";
import createSharedAxios from "./axios-shared.config";

const axiosBaseConfig = createSharedAxios({
	baseURL: allEnvs.baseUrl,
	timeout: allEnvs.apiTimeout,
});

export default axiosBaseConfig;
